/**
 * Library依存
 * slectize.js
 */
'use strict'
import modal from './_modules/v-select.js'
import createDrawer from './_modules/createDrawer.js'
import createInfoRecruit from './_modules/createInfoRecruit.js'
import drawer from './_modules/drawer.js'
import scroll from './_modules/scroll.js'
import tabui from './_modules/tabui.js'
import getCurrent from './_modules/getCurrent.js'
import smoothScroll from './_modules/smoothScroll.js'
import scrollTopBottom from './_modules/scrollTopBottom.js'
import swiper from './_modules/swiper.js'

/*
 * webpack使用（babel）
 * Linter：JavaScript Standard Style
 * 参考：https://standardjs.com/index.html
 * 参考：http://youmightnotneedjquery.com/
 * 参考：https://qiita.com/tatesuke/items/b9548dd484b01b139b74#%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88
 */
class AFV {
  /**
   * 初期実行
   */
  constructor () {
    this.ua = this.setUA()
    this.el = this.setElement()
    this.event = this.setEvent()
    this.ex = this.setMethods()
    this.path = this.setPath()

    /*
     * ページが読み込まれてからの処理
     */
    this.event.ready(e => {
      this.ex.addClass(this.el.html, 'ready')
      this.el.html.className = 'ready  ' + this.ua.classStr
      getCurrent(this)

      window.addEventListener('load', () => {
        this.ex.addClass(this.el.html, 'complete')
      }, false)
    })
  }

  /**
   * ユーザーエージェント関係の取得
   * -- ブラウザ、デバイス
   */
  setUA () {
    let obj = {} // データ格納用
    const UA = window.navigator.userAgent.toLowerCase()

    /* ブラウザチェック */
    const checkBrowser = (() => {
      if (UA.indexOf('edge') !== -1) {
        return 'edge'
      } else if (UA.indexOf('iemobile') !== -1) {
        return 'iemobile'
      } else if (UA.indexOf('trident/7') !== -1) {
        return 'ie11'
      } else if (UA.indexOf('msie') !== -1 && UA.indexOf('opera') === -1) {
        return 'ie'
      } else if (UA.indexOf('chrome') !== -1 && UA.indexOf('edge') === -1) {
        return 'chrome'
      } else if (UA.indexOf('safari') !== -1 && UA.indexOf('chrome') === -1) {
        return 'safari'
      } else if (UA.indexOf('opera') !== -1) {
        return 'opera'
      } else if (UA.indexOf('firefox') !== -1) {
        return 'firefox'
      } else {
        return ''
      }
    })()

    /* デバイスチェック */
    const checkDevice = (() => {
      if (UA.indexOf('iphone') !== -1 || UA.indexOf('ipod') !== -1) {
        return 'iphone'
      } else if (UA.indexOf('ipad') !== -1) {
        return 'ipad'
      } else if (UA.indexOf('android') !== -1) {
        return 'android'
      } else if (UA.indexOf('windows') !== -1 && UA.indexOf('phone') !== -1) {
        return 'windows_phone'
      } else {
        return ''
      }
    })()

    /* フラグ */
    obj = {
      isIE: (checkBrowser.substr(0, 2) === 'ie' && checkBrowser !== 'iemobile'),
      isMobile: (UA.indexOf('mobi') !== -1 || checkDevice === 'iphone' || (checkDevice === 'windows_phone' && UA.indexOf('wpdesktop') === -1) || checkDevice === 'iemobile'),
      isTouch: ('ontouchstart' in window)
    }
    obj.isTablet = (checkDevice === 'ipad' || (checkDevice === 'android' && !obj.isMobile))

    /* class付与用 */
    const getClassName = _ua => {
      let name = ''

      name += (checkBrowser !== '') ? checkBrowser + ' ' : ''
      name += (checkDevice !== '') ? checkDevice + ' ' : ''
      name += (!_ua.isMobile && !_ua.isTablet) ? 'pc ' : 'sp '
      name += (_ua.isTouch) ? 'touch ' : 'mouse '
      name += (_ua.isIE) ? 'ie ' : ''

      return name
    }

    obj.classStr = getClassName(obj)

    return obj
  }

  /**
   * イベント関係のクロスブラウザ対策
   */
  setEvent () {
    let obj = {}

    const findProperty = (checkEl, propertyObj) => {
      const el = checkEl

      for (let key in propertyObj) {
        if (propertyObj.hasOwnProperty(key) && el.style[key] !== undefined) {
          return propertyObj[key]
        }
      }
    }

    /* リサイズ */
    obj.resize = (this.ua.isMobile || obj.isTablet) ? 'orientationchange' : 'orientationchange resize'

    /* マウスホイール */
    obj.mousewheel = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll'

    /* トランジション - 終了 */
    obj.transitionEnd = findProperty(this.el.check, {
      'transition': 'transitionend',
      'WebkitTransition': 'webkitTransitionEnd',
      'MozTransition': 'mozTransitionEnd',
      'OTransition': 'oTransitionEnd',
      'msTransition': 'MSTransitionEnd'
    })

    /* アニメーション - 終了 */
    obj.animationEnd = findProperty(this.el.check, {
      'animation': 'animationend',
      'WebkitAnimation': 'webkitAnimationEnd',
      'MozAnimation': 'mozAnimationEnd',
      'OAnimation': 'oAnimationEnd',
      'msAnimation': 'MSAnimationEnd'
    })

    /* タッチ操作の座標イベント */
    obj.touchPosition = e => {
      if (typeof e === 'undefined') {
        return false
      }

      const original = e.originalEvent
      let x, y

      if (original.changedTouches) {
        x = original.changedTouches[0].pageX
        y = original.changedTouches[0].pageY
      } else {
        x = e.pageX
        y = e.pageY
      }

      return [x, y]
    }

    /* ドキュメントが読み込まれたときの動作 */
    obj.ready = eventHandler => {
      if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        eventHandler()
      } else {
        document.addEventListener('DOMContentLoaded', eventHandler)
      }
    }

    return obj
  }

  /**
   * 要素
   */
  setElement () {
    return {
      check: document.createElement('div'),
      html: document.documentElement,
      body: document.body,
      scrolling: typeof document.scrollingElement !== 'undefined' ? document.scrollingElement : document.documentElement
    }
  }

  /**
   * 拡張機能
   */
  setMethods () {
    let obj = {}

    /**
     * isArray オブジェクトが配列か判断する
     * @param  object
     * @return Boolean
     */
    obj.isArray = obj => {
      return Array.isArray(obj) && obj[0]
    }

    /**
     * 引数に設定した値の型を取得
     * @param  {Object} obj 対象
     * @return {String}     型
     * [TODO] babelするとエラーになる - 設定 useBuiltIns: 'usage'
     */
    obj.type = obj => {
      return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase()
    }

    /**
     * クラスの付与
     * @param {Object}   elements  classでもidでもなんでも可
     * @param {String}   name      class名
     * @param {Function} _callback コールバック
     */
    obj.setClass = (elements, name, _callback) => {
      const length = elements.length

      if (length) {
        for (let i = 0; i < length; i++) {
          elements[i].classList.add(name)

          if (_callback) _callback(elements[i])
        }
      } else {
        elements.classList.add(name)

        if (_callback) _callback(elements)
      }
    }

    /**
     * クラスの付与
     * @param {Object}   elements  classでもidでもなんでも可
     * @param {String}   name      class名
     * @param {Function} _callback コールバック
     * 配列の場合は1つづつ処理（classList.addで複数クラスを付与する際に IE11 では対応してないのでその対策）
     */
    obj.addClass = (elements, name, _callback) => {
      if (obj.isArray(name)) {
        const nameLength = name.length

        for (let i = 0; i < nameLength; i++) {
          obj.setClass(elements, name[i], _callback)
        }
      } else {
        obj.setClass(elements, name, _callback)
      }
    }

    /**
     * クラスの削除
     * @param {Object}   elements  classでもidでもなんでも可
     * @param {String}   name      class名
     * @param {Function} _callback コールバック
     */
    obj.setClassRemove = (elements, name, _callback) => {
      const length = elements.length

      if (length) {
        for (let i = 0; i < length; i++) {
          elements[i].classList.remove(name)

          if (_callback) _callback(elements[i])
        }
      } else {
        elements.classList.remove(name)

        if (_callback) _callback(elements)
      }
    }

    /**
     * クラスの削除
     * @param {Object}   elements  classでもidでもなんでも可
     * @param {String}   name      class名
     * @param {Function} _callback コールバック
     * 配列の場合は1つづつ処理（classList.removeで複数クラスを削除する際に IE11 では対応してないのでその対策）
     */
    obj.removeClass = (elements, name, _callback) => {
      if (obj.isArray(name)) {
        const nameLength = name.length

        for (let i = 0; i < nameLength; i++) {
          obj.setClassRemove(elements, name[i], _callback)
        }
      } else {
        obj.setClassRemove(elements, name, _callback)
      }
    }

    /**
     * 最初の子要素としてエレメントを追加する
     *
     * return <-- ここ
     * <div>対象</div>
     *
     * @param  {Object} el         対象要素
     * @param  {String} htmlString 挿入するコンテンツ
     */
    obj.before = (el, htmlString) => {
      el.insertAdjacentHTML('beforebegin', htmlString)
    }

    /**
     * 各要素の後ろにコンテンツを挿入する
     *
     * <div>対象</div>
     * return <-- ここ
     *
     * @param  {Object} el         対象要素
     * @param  {String} htmlString 挿入するコンテンツ
     */
    obj.after = (el, htmlString) => {
      el.insertAdjacentHTML('afterend', htmlString)
    }

    /**
     * 要素の直前に挿入
     *
     * <div>
     *   return <-- ここ
     *   対象
     * </div>
     *
     * @param  {Object} el         対象要素
     * @param  {String} htmlString 挿入するコンテンツ
     */
    obj.prepend = (el, htmlString) => {
      el.insertAdjacentHTML('afterbegin', htmlString)
    }

    /**
     * 指定した要素の子Nodeのリストの最後に、Nodeを挿入
     *
     * <div>
     *   対象
     *   return <-- ここ
     * </div>
     *
     * @param  {Object} parent 対象要素
     * @param  {Object} htmlString  子として挿入するコンテンツ
     */
    obj.append = (parent, htmlString) => {
      parent.insertAdjacentHTML('beforeend', htmlString)
    }

    /**
     * 配列から条件を満たさない要素を取り除く
     * @param  {String}  selector 条件にかけるセレクター
     * @param  {Function} fn      条件関数
     * @return {Object}
     */
    obj.filter = (selector, fn) => {
      return Array.prototype.filter.call(document.querySelectorAll(selector), fn)
    }

    /**
     * 指定要素が持つ全子孫要素から、指定条件式に合致するものを探す
     * @param  {Object} parent セレクター
     * @param  {String} selector セレクター
     * @return {Object}
     */
    obj.find = (parent, selector) => {
      return parent.querySelectorAll(selector)
    }

    /**
     * 要素の位置を返す
     * @param {Object} el 対象要素
     * @return {Object}
     */
    obj.offset = el => {
      const rect = el.getBoundingClientRect()

      return {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft
      }
    }

    /**
     * 要素の高さ（padding（上下）,border（上下））を取得、第二引き数をtrueでマージンも含めた値を取得
     * @param  {Object}  el       対象要素
     * @param  {Boolean} isMargin マージンを含めるかどうか
     * @return {Number}           値
     */
    obj.outerHeight = (el, isMargin) => {
      if (isMargin === true) {
        let height = el.offsetHeight
        const style = window.getComputedStyle(el)

        height += parseInt(style.marginTop) + parseInt(style.marginBottom)
        return height
      } else {
        return el.offsetHeight
      }
    }

    /**
     * 要素の幅（padding（左右）,border（左右））を取得、第二引き数をtrueでマージンも含めた値を取得
     * @param  {Object}  el       対象要素
     * @param  {Boolean} isMargin マージンを含めるかどうか
     * @return {Number}           値
     */
    obj.outerWidth = (el, isMargin) => {
      if (isMargin === true) {
        let width = el.offsetWidth
        const style = window.getComputedStyle(el)

        width += parseInt(style.marginLeft) + parseInt(style.marginRight)
        return width
      } else {
        return el.offsetWidth
      }
    }

    /**
     * 各要素の兄弟要素を全て返す。
     * @param  {Object} el 対象要素
     * @return {bject}    兄弟要素
     */
    obj.siblings = el => {
      Array.prototype.filter.call(el.parentNode.children, function (child) {
        return (child !== el) ? child : null
      })
    }

    /**
     * 指定要素からdocument方向に遡って走査し、セレクタにマッチする最初の祖先要素を返す
     * @param  {Object} node     対象要素
     * @param  {String} selector セレクタ
     * @return {Object}          セレクタにマッチする最初の祖先要素
     */
    obj.closest = (node, selector) => {
      const matchesSelector = node.matches || node.webkitMatchesSelector || node.mozMatchesSelector || node.msMatchesSelector

      // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
      return (node.closest || function (_selector) {
        do {
          // nodeとselectorがマッチしたら返す
          if ((matchesSelector).call(node, _selector)) {
            return node
          }
          // マッチしなかったら親要素を代入
          node = node.parentElement || node.parentNode
        } while (node !== null && node.nodeType === 1)

        return null
      }).call(node, selector)
    }

    /**
     * htmlに設定されているルート取得用データ属性を利用してルートを取得
     * @param  {String} rootAttr 対象データ属性（data-rootなど）
     * @return {String}          ルート
     */
    obj.getRoot = rootAttr => {
      return (this.el.html.getAttribute(rootAttr)) ? this.el.html.getAttribute(rootAttr) : '/'
    }

    /**
     * イベントの実行
     * @param  {Object} el        対象要素
     * @param  {String} eventName イベント名
     * @return {}
     */
    obj.trigger = (el, eventName) => {
      const event = document.createEvent('HTMLEvents')
      event.initEvent(eventName, true, false)
      el.dispatchEvent(event)
    }

    /**
     * 連想配列のマージ
     * @return {Object} マージ後のオブジェクト
     * アロー関数では、argumentsが使えないためfunctionで
     */
    obj.extend = function () {
      let i = 1
      let key
      let length = arguments.length
      let result = arguments[0] || {} // 引数がなければ空のオブジェクトを返す
      let isDeep = false

      // 第1引数がtrueだったときディープコピー
      if (result === true) {
        ++i
        result = arguments[1] || {}
        isDeep = true
      }

      // 引数の数だけループ
      // 第1引数は除く（ディープコピーの場合は第2引数も）
      for (; i < length; ++i) {
        for (key in arguments[i]) {
          if (arguments[i].hasOwnProperty(key)) {
            // ディープコピーの場合は再帰呼び出し
            if (isDeep && Object.prototype.toString.call(arguments[i][key]) === '[object Object]') {
              result[key] = this.ex.extend(result[key], arguments[i][key])
            } else {
              result[key] = arguments[i][key]
            }
          }
        }
      }

      return result
    }

    return obj
  }

  /**
   * パス関係
   */
  setPath () {
    let obj = {}

    /* ルートの取得 */
    obj.root = this.ex.getRoot('data-root')
    obj.assets = this.ex.getRoot('data-assets')

    return obj
  }
}

const APP = new AFV()

/**
 * SVGスプライト用
 */
;(() => {
  $.ajax({
    type: 'get',
    url: APP.path.assets + 'svg/sprite.svg',
    timeout: 10000
  })
    .done(function (data) {
      var svg = $(data).find('svg')
      $('body').prepend(svg)
    })
    .fail(function (data) {
      if (window.console && typeof window.console.log === 'function') {
        console.log('[Ajax Fail] sprite.svg の取得に失敗いたしました。')
      }
    })
})()

createDrawer(APP)
createInfoRecruit(APP)
smoothScroll(APP)

APP.modal = modal(APP)
APP.ex.scroll = scroll(APP)
APP.ex.tabui = tabui(APP)
APP.ex.drawer = drawer(APP)
APP.ex.scrollTopBottom = scrollTopBottom(APP)
APP.ex.swiper = swiper(APP)
